import TextInput from "../../../component/TextInput/TextInput";
import Select from "../../../component/Select/Select";
import {PickDateTime} from "../../../component/PickDate/PickDate";
import {Fragment, useEffect, useState} from "react";
import Loading from "../../../component/Loading/Loading";
import {getAllPeopleDividedByRole} from "../../../component/PersonForm/functions";
import TreeSelect from "../../../component/TreeSelect/TreeSelect";
import {listToTree} from "../../../assets/functions";
import {getCreditCardObjectByPersonId} from "../../CreditCards/functions";

const TransactionForm = ({transaction, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [allPeople, setAllPeople] = useState([]);
    const transactionTypeOptions = [
        {
            label: "افزایش",
            value: "INCREASE",
        }, {
            label: "کاهش",
            value: "DECREASE",
        },
    ];
    const transactionMethodOptions = [
        {
            label: "درگاه پرداخت",
            value: "IPG",
        }, {
            label: "ساتنا",
            value: "SATNA",
        }, {
            label: "پل",
            value: "POL",
        }, {
            label: "پایا",
            value: "PAYA",
        }, {
            label: "کارت به کارت",
            value: "CARD",
        }, {
            label: "دستی",
            value: "MANUAL",
        }, {
            label: "نقدی",
            value: "CASH",
        },
    ];
    const [destinationCardOptions, setDestinationCardOptions] = useState([]);


    useEffect(() => {
        (async () => {
            setAllPeople(await getAllPeopleDividedByRole());
            setIsLoading(false);
        })();

    }, []);

    useEffect(() => {
        setIsLoading(true);
        (async () => {
            if (transaction.personId) {
                const allCreditcard = await getCreditCardObjectByPersonId(transaction.personId);
                if (allCreditcard.length == 0) {
                    setIsLoading(false);
                    return;
                }

                setDestinationCardOptions([{label: "انتخاب کنید...", value: "CHOOSING"}, ...allCreditcard])
            }
            setIsLoading(false);
        })();

    }, [transaction.personId]);


    const changeTransaction = (key, value) => {
        const newTransaction = {...transaction, [key]: value};
        if (key == "method") {
            newTransaction.idOfTransaction = "";
            newTransaction.destinationCardId = "";
        } else if (key == "sendMessage" && value) {
            newTransaction.sendGiftMessage = false;
        } else if (key == "sendGiftMessage" && value) {
            newTransaction.sendMessage = false;
        }
        onChange(newTransaction);
    }

    if (isLoading)
        return <Loading/>

    return (
        <div className={"row"}>
            <div className="col-md-6">
                <Select label={"نوع عملیات"} options={transactionTypeOptions} value={transaction.type}
                        onChange={(value) => {
                            changeTransaction("type", value)
                        }}
                />
            </div>
            <div className="col-md-6">
                <PickDateTime label={"زمان تراکنش"} timestamp={transaction.timestamp}
                              onChange={(value) => {
                                  changeTransaction("timestamp", value)
                              }}
                />
            </div>
            <div className="col-md-6">
                <TextInput label={"مبلغ (تومان)"} type={"number"} value={transaction.amount}
                           onChange={(value) => {
                               changeTransaction("amount", value)
                           }}
                />
            </div>
            <div className="col-12">
                <TreeSelect label={"صاحب حساب"} mode={"radioSelect"}
                            data={listToTree(allPeople, [transaction.personId])} onChange={(value) => {
                    const newPersonId = value.length == 1 && !isNaN(value[0]) ? value[0] : "";
                    changeTransaction("personId", newPersonId)
                }}/>
            </div>
            <div className="col-12">
                <div className="row">
                    <div className="col-md-6">
                        <Select label={"روش عملیات"} options={transactionMethodOptions} value={transaction.method}
                                onChange={(value) => {
                                    changeTransaction("method", value)
                                }}
                        />
                    </div>
                    {transaction.method != "MANUAL" && transaction.method != "CASH" && <div className="col-md-6">
                        <TextInput classname={"ltr"} label={"کد پیگیری"} value={transaction.idOfTransaction}
                                   onChange={(value) => {
                                       changeTransaction("idOfTransaction", value)
                                   }}
                        />
                    </div>}
                </div>
            </div>
            {transaction.method != "IPG" && transaction.method != "MANUAL" && transaction.method != "CASH" &&
                <div className="col-12">
                    {destinationCardOptions.length == 0 &&
                        <div className={"alert alert-warning"}>اطلاعات حساب یافت نشد!</div>}
                    {destinationCardOptions.length > 0 &&
                        <Select label={"اطلاعات حساب مقصد"} options={destinationCardOptions}
                                value={transaction.destinationCardId}
                                onChange={(value) => {
                                    changeTransaction("destinationCardId", value)
                                }}/>}
                </div>}

            <div className="col-md-6">
                <TextInput label={"توضیح برای نمایش مشتری"} value={transaction.description} onChange={(value) => {
                    changeTransaction("description", value)
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput label={"توضیحات داخلی"} value={transaction.privateDescription} onChange={(value) => {
                    changeTransaction("privateDescription", value)
                }}/>
            </div>

            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="form-input">
                            <input className="form-check-input" type="checkbox" checked={transaction.isVerified}
                                   id="isVerified"
                                   onChange={() => {
                                       changeTransaction("isVerified", !transaction.isVerified)
                                   }}/>
                            <label className="form-check-label me-2" htmlFor="isVerified">
                                تراکنش مورد تایید است و در محاسبات لحاظ گردد.
                            </label>
                        </div>

                        {transaction.type == "INCREASE" && <Fragment>
                            <div className="form-input">
                                <input className="form-check-input" type="checkbox" checked={transaction.sendMessage}
                                       id="sendMessage"
                                       onChange={() => {
                                           changeTransaction("sendMessage", !transaction.sendMessage)
                                       }}/>
                                <label className="form-check-label me-2" htmlFor="sendMessage">
                                    اس ام اس اطلاع رسانی ارسال شود.
                                </label>
                            </div>


                            <div className="form-input">
                                <input className="form-check-input" type="checkbox"
                                       checked={transaction.sendGiftMessage}
                                       id="sendGiftMessage"
                                       onChange={() => {
                                           changeTransaction("sendGiftMessage", !transaction.sendGiftMessage)
                                       }}/>
                                <label className="form-check-label me-2" htmlFor="sendGiftMessage">
                                    اس ام اس هدیه ارسال شود.
                                </label>
                            </div>
                        </Fragment>
                        }
                    </div>
                </div>
            </div>


        </div>
    );
}

export default TransactionForm;